<template>
  <el-row >
    <el-col :lg="{span:'17'}" :md="{span:'16'}" :sm="{span:'15'}" :xs="{span:'24'}" >
      <img :src="image_auth" class="image-auth"/>
    </el-col>
    <el-col :lg="{span:'6', offset: '1'}" :md="{span:'7', offset: '1'}" :sm="{span:'8', offset: '1'}" :xs="{span:'24'}" class="auth-holder" >
      <!-- <el-card v-loading="loading" class="box-card" style="margin-top: 20px;"> -->
        
        <h1>Login <img :src="image_brand" class="image-brand" /></h1>
        <el-alert
          v-if="error"
          :title="error"
          type="error"
          center
          :closable="false"
          show-icon>
        </el-alert>
        <el-form class="auth-form" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" size="small" label-position="top" hide-required-asterisk >
          <el-form-item label="Email" prop="email" :error="errorForm.email">
            <el-input v-model="ruleForm.email" @keyup.enter.native="submitForm('ruleForm')"></el-input>
          </el-form-item>
          <el-form-item label="Password" prop="password" :error="errorForm.password">
            <el-input type="password" v-model="ruleForm.password" show-password @keyup.enter.native="submitForm('ruleForm')"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')" :loading="loading">Masuk</el-button>
          </el-form-item>
        </el-form>
        <div style="padding-bottom: 5px">
          <router-link :to="{name: 'lupa-aja'}" style="text-decoration:none;" >lupa password?</router-link>
        </div>
        belum punya akun? daftar <router-link :to="{name: 'register'}" style="text-decoration:none;">disini</router-link>
        
      <!-- </el-card> -->
    </el-col>
  </el-row>
</template>

<script>
import {auth} from '../../firebase'

export default {
  data() {
    return {
      ruleForm: {
        email: '',
        password: ''
      },
      error: '',
      rules: {
        email: [
          { required: true, message: 'Masukkan email', trigger: 'blur' },
          { type: 'email', message: 'Email tidak valid', trigger: 'blur' },
        ],
        password: [
          { required: true, message: 'Masukkan password', trigger: 'blur' }
        ]
      },
      errorForm: {
        email: '',
        password: ''
      },
      loading: false,
      image_brand: require('../../assets/logo-putih.png'),
      image_auth: require('../../assets/background-auth.png'),
    }
  },
  methods: {
    submitForm: function (formName) {
      this.loading = true
      this.error = ''
      this.$refs[formName].validate((valid) => {
        if (valid) {
          auth.signInWithEmailAndPassword(this.ruleForm.email, this.ruleForm.password)
            .then(() => {
                this.$router.go({name: 'kata-pengantar'})
                this.loading = false
            })
            .catch((error) => {
              this.loading = false
              switch(error.code) {
                case 'auth/invalid-email':
                  this.error = 'Format email salah'
                  break;
                case 'auth/wrong-password':
                  this.error = 'Password salah'
                  break;
                case 'auth/user-not-found':
                  this.error = 'Email belum terdaftar'
                  break;
                case 'auth/too-many-requests':
                  this.error = 'Anda mencoba terlalu sering, silahkan coba lagi nanti'
                  break;
                default: 
                  this.error = 'Terjadi kesalahan (' + error.message + ')'
              }
            })
        } else {
          this.loading = false
          return false;
        }
      });
    }
  },
  mounted() {

  }
}
</script>

<style scoped>
  /* @import '../../assets/style-auth.css'; */
</style>